/*
 * @tip 一些共享的数据 抽取原则：小块数据，没必要单独出来的
 * @tip 使用vuex管理：1.静态；2.非静态
 */

export const state = () => ({
	//静态数据
	page: {
		limit: 10
	},
	//非静态数据
	currentPage: 'certquery',
})

export const actions = {
	async setCurrentPage ({
		commit,
		state
	}, page) {
		commit('setCurrentPage', page)
	},
}

export const mutations = {
	setCurrentPage (state, page) {
		state.currentPage = page
	},
}
